<template>
  <!-- <GlobalLayout> -->
    <div class="tabs">
    <context-menu :itemList="menuItemList" :visible.sync="menuVisible" @select="onMenuSelect" />
    <a-tabs
      @contextmenu.native="e => onContextmenu(e)"
      :active-key="activePage"
      style="margin-top: -8px; margin-bottom: 8px"
      :hide-add="true"
      type="editable-card"
      @change="changePage"
      @edit="editPage">
      <a-tab-pane :id="page.fullPath" :key="page.fullPath" v-for="page in pageList">
        <span slot="tab" :pagekey="page.fullPath">{{page.name}}</span>
      </a-tab-pane>
    </a-tabs>
    <!-- <transition name="page-toggle">
      <keep-alive v-if="multipage">
        <router-view />
      </keep-alive>
      <router-view v-else />
    </transition> -->
  <!-- </GlobalLayout> -->
  </div>
</template>

<script>
import ATabs from "ant-design-vue/lib/tabs"
// import GlobalLayout from './GlobalLayout'
import ContextMenu from '@/components/Menu/Contextmenu'
const ATabPane=ATabs.TabPane
export default {
  name: 'MenuView',
  components: {ContextMenu,ATabs,ATabPane},
  data () {
    return {
      pageList: this.$localstorage.getLocalStorage('pageList')?JSON.parse(this.$localstorage.getLocalStorage('pageList')):[],
      linkList: this.$localstorage.getLocalStorage('linkList')||[],
      activePage: this.$localstorage.getLocalStorage('activePage')||"",
      menuVisible: false,
      menuItemList: [
        { key: '1', icon: 'arrow-left', text: '关闭左侧' },
        { key: '2', icon: 'arrow-right', text: '关闭右侧' },
        { key: '3', icon: 'close', text: '关闭其它' }
      ]
    }
  },
  computed: {
    multipage () {
      return true //多页标签
    }
  },
  created () {
    if(!this.pageList.filter(item=>item.name===this.$route.meta.title)){
      this.pageList.push({
        name:this.$route.meta.title,
        fullPath:this.$route.fullPath,
        path:this.$route.path
      })
    }
    // this.pageList=Array.from(new Set(this.pageList)); //去重（）
    this.$localstorage.putLocalStorage('pageList', JSON.stringify(this.pageList))
    if(!this.linkList.filter(item=>item===this.$route.fullPath)){
      this.linkList.push(this.$route.fullPath)
    }
    // this.linkList=Array.from(new Set(this.linkList)); 
    this.$localstorage.putLocalStorage('linkList', this.linkList)
    this.activePage = this.$route.fullPath
    this.$localstorage.putLocalStorage('activePage', this.activePage )
  },
  watch: {
    '$route': function (newRoute, oldRoute) {
      this.activePage = newRoute.fullPath
      this.$localstorage.putLocalStorage('activePage', this.activePage)
      if (!this.multipage) {
        this.linkList = [newRoute.fullPath]
        this.$localstorage.putLocalStorage('linkList', this.linkList)
        this.pageList = [{
          name:newRoute.meta.title,
          fullPath:newRoute.fullPath,
          path:newRoute.path,
        }]
        this.$localstorage.putLocalStorage('pageList', JSON.stringify(this.pageList))
      } else if (this.linkList.indexOf(newRoute.fullPath) < 0) {
        this.linkList.push(newRoute.fullPath)
        // this.linkList=Array.from(new Set(this.linkList)); 
        this.$localstorage.putLocalStorage('linkList', this.linkList)
        this.pageList.push({
          name:newRoute.meta.title,
          fullPath:newRoute.fullPath,
          path:newRoute.path,
        })
        // this.pageList=Array.from(new Set(this.pageList)); 
        this.$localstorage.putLocalStorage('pageList', JSON.stringify(this.pageList))
      }
    },
    'activePage': function (key) {
      this.$router.push(key)
    },
    'multipage': function (newVal, oldVal) {
      if (!newVal) {
        this.linkList = [this.$route.fullPath]
        this.$localstorage.putLocalStorage('linkList', this.linkList)
        this.pageList = [this.$route]
        this.$localstorage.putLocalStorage('pageList', JSON.stringify(this.pageList))
      }
    }
  },
  methods: {
    changePage (key) {
      this.activePage = key
      this.$localstorage.putLocalStorage('activePage', this.activePage)
    },
    editPage (key, action) {
      this[action](key)
    },
    remove (key) {
      if (this.pageList.length === 1) {
        this.$notification['warning']({
                  message: '这是最后一页，不能再关闭了啦',
                })
        return
      }
      this.pageList = this.pageList.filter(item => item.fullPath !== key)
      this.$localstorage.putLocalStorage('pageList', JSON.stringify(this.pageList))
      let index = this.linkList.indexOf(key)
      this.linkList = this.linkList.filter(item => item !== key)
      this.$localstorage.putLocalStorage('linkList', this.linkList)
      index = index >= this.linkList.length ? this.linkList.length - 1 : index
      this.activePage = this.linkList[index]
      this.$localstorage.putLocalStorage('activePage', this.activePage)
    },
    onContextmenu (e) {
      const pagekey = this.getPageKey(e.target)
      if (pagekey !== null) {
        e.preventDefault()
        this.menuVisible = true
      }
    },
    /**
     * 由于ant-design-vue组件库的TabPane组件暂不支持自定义监听器，无法直接获取到右键target所在标签页的 pagekey 。故增加此方法用于
     * 查询右键target所在标签页的标识 pagekey ，以用于自定义右键菜单的事件处理。
     * 注：TabPane组件支持自定义监听器后可去除该方法并重构 ‘自定义右键菜单的事件处理’
     * @param target 查询开始目标
     * @param count 查询层级深度 （查找层级最多不超过3层，超过3层深度直接返回 null）
     * @returns {String}
     */
    getPageKey (target, depth) {
      depth = depth || 0
      if (depth > 2) {
        return null
      }
      let pageKey = target.getAttribute('pagekey')
      pageKey = pageKey || (target.previousElementSibling ? target.previousElementSibling.getAttribute('pagekey') : null)
      return pageKey || (target.firstElementChild ? this.getPageKey(target.firstElementChild, ++depth) : null)
    },
    onMenuSelect (key, target) {
      let pageKey = this.getPageKey(target)
      switch (key) {
        case '1':
          this.closeLeft(pageKey)
          break
        case '2':
          this.closeRight(pageKey)
          break
        case '3':
          this.closeOthers(pageKey)
          break
        default:
          break
      }
    },
    closeOthers (pageKey) {

      let index = this.linkList.indexOf(pageKey)
      this.linkList = this.linkList.slice(index, index + 1)
      this.$localstorage.putLocalStorage('linkList', this.linkList)
      this.pageList = this.pageList.slice(index, index + 1)
      this.$localstorage.putLocalStorage('pageList', JSON.stringify(this.pageList))
      this.activePage = this.linkList[0]
      this.$localstorage.putLocalStorage('activePage', this.activePage)
    },
    closeLeft (pageKey) {

      let index = this.linkList.indexOf(pageKey)
      this.linkList = this.linkList.slice(index)
      this.$localstorage.putLocalStorage('linkList', this.linkList)
      this.pageList = this.pageList.slice(index)
      this.$localstorage.putLocalStorage('pageList', JSON.stringify(this.pageList))
      if (this.linkList.indexOf(this.activePage) < 0) {
        this.activePage = this.linkList[0]
        this.$localstorage.putLocalStorage('activePage', this.activePage)
      }
    },
    closeRight (pageKey) {
      let index = this.linkList.indexOf(pageKey)
      this.linkList = this.linkList.slice(0, index + 1)
      this.$localstorage.putLocalStorage('linkList', this.linkList)
      this.pageList = this.pageList.slice(0, index + 1)
      this.$localstorage.putLocalStorage('pageList', JSON.stringify(this.pageList))
      if (this.linkList.indexOf(this.activePage < 0)) {
        //如果右边被删除的选项中包含当前激活页面，则将linkList中最后一条作为新的当前激活页面；如不包含，则不变
        if(this.linkList.filter(item=>item===this.activePage!=[])){
          this.activePage = this.linkList[this.linkList.length - 1]
          this.$localstorage.putLocalStorage('activePage', this.activePage)
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Page/MenuView.vue